// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2020-11-01 16:01:39 +0100 (Sun, 01 Nov 2020) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 114547 $
//  Purpose   : rules for tabs
// =============================================================================
// ---Third-party imports

// ---Framework imports
import {isFunction} from 'ldash'
import log from 'uix/logging'
import {dict, get, flatten, mapItems, has, filterItems, isArray, values} from 'ldash'

// ---Local imports
import {getTreeTplClasses} from './utils'

// ---Globals
const configureTab = (classes2tabs, className, name, condition) => {
  let tabs = classes2tabs[className]
  if (!isArray(tabs)) {
    // tpl class removed by config
  } else if (condition && !tabs.includes(name)) {
    // dont overide datatype or enabled() decisions
  } else if (!condition && tabs.includes(name)) {
    // mutation
    classes2tabs[className] = tabs.filter(n => n !== name)
  }
}

export const tabsForTreeNode = (
  request,
  iconfig,
  classCfgs,
  dconfig,
  record = {},
  treeNode = {}
) => {
  /* return list of views (class/tab) for current domain + tree record info
  :param record.details: some tabs depend on custom record level details like pdf availability
   */
  let dname = dconfig.domain.name
  let dtype = dconfig.domain.type

  let {tconfig, nodeData, details} = record
  let datatype = tconfig?.internalDatatype
  let subtype = tconfig?.internalType
  let typeName = tconfig?.name

  let isEnabledClassTab = class_tab_cfg => {
    /* check .enabled callable from view configs
    this is stronger than the .cfg callable as we have record level data here
    (we can additionally check types config values)
    */
    if (class_tab_cfg.authNeeded === true) {
      return false
    }
    if (!isFunction(class_tab_cfg.enabled)) {
      return true
    }
    return class_tab_cfg.enabled({
      iconfig,
      request,
      // domain level stuff, also in .cfg() available
      dname,
      dtype,
      dconfig,
      // record level stuff
      typeName,
      datatype,
      subtype,
      tconfig,
      // tree node
      treeNode,
    })
  }

  let classes2tabs = dict(
    getTreeTplClasses(classCfgs)
      .filter(classname => classCfgs[classname])
      .filter(classname => isEnabledClassTab(classCfgs[classname]))
      .map(classname => [
        classname,
        filterItems(
          classCfgs[classname].tabs,
          (name, tab) =>
            isEnabledClassTab(tab) &&
            // has survived a enabled check or has a simple datatype condition
            (tab.enabled ||
              classCfgs[classname].enabled ||
              get(tab, 'datatype', []).includes(datatype))
        ).map(e => e[0]),
      ])
  )

  if (tconfig) {
    // XXX: these checks were introduced before the isEnabledClassTab check
    let isBadType2 = datatype == 2 && (subtype == 52 || subtype == 9 || subtype == 53)
    configureTab(classes2tabs, 'capsule', 'local', !isBadType2)
    configureTab(classes2tabs, 'text', 'id', !isBadType2)
    configureTab(classes2tabs, 'analytics', 'context', !isBadType2)

    details = details || {}

    // dt1 with substructs/mds-only will fail this test
    //~ configureTab(
    //~ classes2tabs,
    //~ 'tree',
    //~ 'viewer',
    //~ !isBadType2 && (datatype == 3 || details.haschildren)
    //~ )

    configureTab(classes2tabs, 'tree', 'pdf', details.pdf_id)
    configureTab(
      classes2tabs,
      'text',
      'id',
      // there is only a ocr_id for page but we want to show the text tab also for substructs
      nodeData && (datatype == 0 || details.ocr_id)
    )
  }

  // auto via tcfg @cfg
  //~ configureTab(classes2tabs, 'capsule', 'view', datatype == 1 && iconfig.preservation.on)
  let res = flatten(
    mapItems(classes2tabs, (classname, tabs) => tabs.map(tabname => [classname, tabname]))
  )
  return res
}
